(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/high-five-next-race/assets/javascripts/high-five-next-race.js') >= 0) return;  svs.modules.push('/components/racing/high-five-next-race/assets/javascripts/high-five-next-race.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const {
  calculateTimeRemaining
} = svs.racing.high_five_next_race.util;
const init = options => {
  const el = options.el;
  const model = {
    highFive: _objectSpread(_objectSpread({}, options.highFive), {}, {
      inverted: options.highFive.theme === 'inverted'
    }),
    nextRace: _objectSpread(_objectSpread({}, options.nextRace), {}, {
      inverted: options.nextRace.theme === 'inverted'
    }),
    data: options.data
  };
  let nextRaceTickInterval;
  const trackClick = () => {
    var _options$areaName;
    const name = options.renderHighFive ? 'next-highfive-promo' : 'next-race-promo';
    const pathName = window.location.pathname;
    const areaName = (_options$areaName = options.areaName) !== null && _options$areaName !== void 0 ? _options$areaName : 'promo-placed-outside-widget';
    if (areaName) {
      svs.components.analytics.trackPromoClick({
        id: pathName,
        name,
        position: areaName
      });
    }
  };
  const setupTracking = () => {
    el.on('click', '.js-play-button', trackClick);
  };
  const render = () => {
    el.html(svs.racing.high_five_next_race.templates.root(model));
  };
  const nextRaceTick = () => {
    const now = new Date();
    const countTo = new Date(model.data.race.startTime);
    if (dateFns.differenceInSeconds(countTo, now) <= 0) {
      clearInterval(nextRaceTickInterval);
      model.data.showCountdown = false;
      render();
    } else {
      model.data.countdown = calculateTimeRemaining(new Date(model.data.race.startTime));
      const timeLeft = el.find('.time-left');
      if (timeLeft && timeLeft[0]) {
        timeLeft[0].innerText = "".concat(model.data.countdown.hours, ":").concat(model.data.countdown.minutes, ":").concat(model.data.countdown.seconds);
      }
    }
  };
  const startNextRaceTick = () => {
    nextRaceTickInterval = setInterval(nextRaceTick, 1000);
  };

  if (!options.data.renderHighFive) {
    startNextRaceTick();
  }
  setupTracking();
};
svs.racing.high_five_next_race.init = init;

 })(window);